const actions = {
  CREATE_NEW_RESERVATION_TABLE_REQUEST: "CREATE_NEW_RESERVATION_TABLE_REQUEST",
  CREATE_NEW_RESERVATION_TABLE_SUCCESS: "CREATE_NEW_RESERVATION_TABLE_SUCCESS",

  EDIT_RESERVATION_TABLE_REQUEST: "EDIT_RESERVATION_TABLE_REQUEST",
  EDIT_RESERVATION_TABLE_SUCCESS: "EDIT_RESERVATION_TABLE_SUCCESS",

  DELETE_RESERVATION_TABLE_REQUEST: "DELETE_RESERVATION_TABLE_REQUEST",
  DELETE_RESERVATION_TABLE_SUCCESS: "DELETE_RESERVATION_TABLE_SUCCESS",

  GET_RESERVATION_TABLE_REQUEST: "GET_RESERVATION_TABLE_REQUEST",
  GET_RESERVATION_TABLE_SUCCESS: "GET_RESERVATION_TABLE_SUCCESS",

  CREATE_NEW_REGION_REQUEST: "CREATE_NEW_REGION_REQUEST",
  CREATE_NEW_REGION_SUCCESS: "CREATE_NEW_REGION_SUCCESS",

  EDIT_REGION_REQUEST: "EDIT_REGION_REQUEST",
  EDIT_REGION_SUCCESS: "EDIT_REGION_SUCCESS",

  DELETE_REGION_REQUEST: "DELETE_REGION_REQUEST",
  DELETE_REGION_SUCCESS: "DELETE_REGION_SUCCESS",

  GET_REGIONS_REQUEST: "GET_REGIONS_REQUEST",
  GET_REGIONS_SUCCESS: "GET_REGIONS_SUCCESS",

  GET_TOUCHSALE_TABLES_PER_REGION_REQUEST:
    "GET_TOUCHSALE_TABLES_PER_REGION_REQUEST",
  GET_TOUCHSALE_TABLES_PER_REGION_SUCCESS:
    "GET_TOUCHSALE_TABLES_PER_REGION_SUCCESS",

  REORDER_REGIONS_REQUEST: "REORDER_REGIONS_REQUEST",
  REORDER_REGIONS_SUCCESS: "REORDER_REGIONS_SUCCESS",

  BUSY_OR_FREE_TABLE_REQUEST: "BUSY_OR_FREE_TABLE_REQUEST",
  BUSY_OR_FREE_TABLE_SUCCESS: "BUSY_OR_FREE_TABLE_SUCCESS",

  createNewReservationTable: (newTableData) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_NEW_RESERVATION_TABLE_REQUEST,
        newTableData,
      });
    };
  },

  editReservationTable: (editTableData) => {
    return (dispatch) => {
      dispatch({
        type: actions.EDIT_RESERVATION_TABLE_REQUEST,
        editTableData,
      });
    };
  },

  deleteReservationTable: (deteleTableData) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_RESERVATION_TABLE_REQUEST,
        deteleTableData,
      });
    };
  },

  getReservationTable: (regionId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_RESERVATION_TABLE_REQUEST,
        regionId,
      });
    };
  },

  createNewRegion: (newRegionData) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_NEW_REGION_REQUEST,
        newRegionData,
      });
    };
  },

  getRegions: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_REGIONS_REQUEST,
      });
    };
  },

  editReservationRegion: (editRegionData) => {
    return (dispatch) => {
      dispatch({
        type: actions.EDIT_REGION_REQUEST,
        editRegionData,
      });
    };
  },

  deleteReservationRegion: (deleteRegionData) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_REGION_REQUEST,
        deleteRegionData,
      });
    };
  },

  getTouchsaleTablesPerRegion: (getTouchsaleTablesData) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_TOUCHSALE_TABLES_PER_REGION_REQUEST,
        getTouchsaleTablesData,
      });
    };
  },

  reorderRegions: (reorderData) => {
    return (dispatch) => {
      dispatch({
        type: actions.REORDER_REGIONS_REQUEST,
        reorderData,
      });
    };
  },

  busyOrFreeTable: (data) => {
    return (dispatch) => {
      dispatch({
        type: actions.BUSY_OR_FREE_TABLE_REQUEST,
        data,
      });
    };
  },
};

export default actions;
